/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 var htmlProduct = $("#bloco-product").html();
 var htmlCard = $("#AjaxCart").html();
 
 
 function removerCarrinho(){
       $("#AjaxCart").html("");
       $("#bloco-product").html(htmlProduct);
   }
 
 function removerProduto(){
    $("#bloco-product").html("");
    $("#AjaxCart").html(htmlCard);
}
$(window).on('load', function() {
    setTimeout(function() {
        console.log('chamei a funcão removerCarrinho');
        removerCarrinho();
    }, 1000);
    });
  
$( ".Icon-Wrapper--clickable" ).click(function() {
    removerProduto();
});
 
$( ".ProductForm__AddToCart" ).click(function() {
    removerProduto();
});
  
  
$( "#close" ).click(function() {
    removerCarrinho();
});
    
$( ".get-rates-custom" ).click(function() {
    removerCarrinho();
});

$( ".PageOverlay" ).click(function() {
    removerCarrinho();
});

/** validate mask form "seja nosso parceiro" **/
$(document).ready(function(){
    $('#contact-form-telefone').mask('(00) 00000-0000');
    $("#contact-form-cpf-cnpj").on('focusin',function(){
        var target = $(this);
        var val = target.val();
        target.unmask();
        val = val.split(".").join("");
        val = val.split("-").join("");
        val = val.split("/").join("");
        target.val(val);
    });
    $("#contact-form-cpf-cnpj").on('focusout',function(){
        var target = $(this);
        var val = target.val();
        val = val.split(".").join("");
        val = val.split("-").join("");
        val = val.split("/").join("");
        if (val.length==11) {
            target.mask("999.999.999-99");
            target.val(val);
        } else {
            if (val.length==14) {
                target.mask("99.999.999/9999-99");
                target.val(val);
            } else {
                target.val('');
            }
        }
    }) 

});



